import { observer } from 'mobx-react-lite';
import { useTypedParams } from 'react-router-typesafe-routes/dom';

import { AppPage } from 'app/common/app-page/features/app-page';
import { PageNotificationsProvider } from 'app/common/notifications/features/page-notifications/page-notifications.provider';
import { PageNotificationsRender } from 'app/common/notifications/features/page-notifications/page-notifications.render';
import { appRoute } from 'app/railways/router/routes';
import { PageContent } from 'app/ui';

import { DetailsTariffProfile } from '../features/tariff-profile/details-tariff-profile/details-tariff-profile';

export const DetailsTariffProfilePage = observer(() => {
  const { tariffProfileId } = useTypedParams(appRoute.TARIFF_PROFILES.DETAILS);
  return (
    <PageNotificationsProvider>
      <AppPage perm="PERM_TARIFF_PROFILE_READ">
        <PageContent>
          <PageNotificationsRender />
        </PageContent>

        <PageContent>
          {tariffProfileId ? (
            <DetailsTariffProfile tariffProfileId={tariffProfileId} />
          ) : (
            'Не указан ID профиля тарифа. Проверьте URL'
          )}
        </PageContent>
      </AppPage>
    </PageNotificationsProvider>
  );
});
